import { supabase } from '../lib/supabase';

export async function scanForImageUsage() {
  console.log('Starting image usage scan...');
  const imageUsage: { [key: string]: string[] } = {};

  try {
    // Get settings to map current image URLs
    const { data: settingsData } = await supabase
      .from('app_settings')
      .select('settings')
      .single()
      .throwOnError();

    console.log('Retrieved settings:', settingsData?.settings?.media?.imageUrls);
    const imageUrls = settingsData?.settings?.media?.imageUrls || {};

    // Add current image URLs to usage
    Object.entries(imageUrls).forEach(([key, url]) => {
      console.log('Processing image URL:', { key, url });
      imageUsage[url as string] = [`media.imageUrls.${key}`];
    });

    // Scan team members
    const { data: teamMembers } = await supabase
      .from('team_members')
      .select('image')
      .throwOnError();

    console.log('Found team members:', teamMembers?.length);
    teamMembers?.forEach(member => {
      if (member.image) {
        if (!imageUsage[member.image]) {
          imageUsage[member.image] = [];
        }
        imageUsage[member.image].push('Team Member Profile Image');
      }
    });

    // Scan podcasts
    const { data: podcasts } = await supabase
      .from('podcasts')
      .select('image_url')
      .throwOnError();

    console.log('Found podcasts:', podcasts?.length);
    podcasts?.forEach(podcast => {
      if (podcast.image_url) {
        if (!imageUsage[podcast.image_url]) {
          imageUsage[podcast.image_url] = [];
        }
        imageUsage[podcast.image_url].push('Podcast Cover Image');
      }
    });

    // Scan news articles
    const { data: articles } = await supabase
      .from('news_articles')
      .select('cover_image')
      .throwOnError();

    console.log('Found articles:', articles?.length);
    articles?.forEach(article => {
      if (article.cover_image) {
        if (!imageUsage[article.cover_image]) {
          imageUsage[article.cover_image] = [];
        }
        imageUsage[article.cover_image].push('News Article Cover Image');
      }
    });

    // Scan news media
    const { data: newsMedia } = await supabase
      .from('news_media')
      .select('url, article_id')
      .throwOnError();

    console.log('Found news media:', newsMedia?.length);
    newsMedia?.forEach(media => {
      if (media.url) {
        if (!imageUsage[media.url]) {
          imageUsage[media.url] = [];
        }
        imageUsage[media.url].push(`News Article Media (Article ID: ${media.article_id})`);
      }
    });

    console.log('Final image usage:', imageUsage);
    return imageUsage;
  } catch (error) {
    console.error('Error scanning for images:', error);
    throw error;
  }
}